import { render } from "./VCardFooter.vue?vue&type=template&id=90b5ed0a"
import script from "./VCardFooter.vue?vue&type=script&lang=js"
export * from "./VCardFooter.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__